import React, { ReactNode, useMemo, useState } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import './style.scss';

type FeedListProps = {
  image?: string;
  className?: string;
  checked?: boolean;
  onSelect?: () => void;
  showCheckBox?: boolean;
  actions?: ReactNode;
  children: ReactNode;
};
const FeedCard = ({
  image,
  showCheckBox,
  className,
  checked,
  onSelect,
  actions,
  children
}: FeedListProps) => {
  const [cardHovered, setCardHovered] = useState(false);

  const checkboxDisplay = useMemo(() => {
    return (cardHovered || checked) && showCheckBox;
  }, [cardHovered, checked, showCheckBox]);

  return (
    <div
      className={`min-h-[213px] cursor-pointer rounded-[10px] bg-white shadow-md relative z-0 transition-all ${className}`}>
      <div
        className='hover:blur-[.7px]'
        style={{
          height: '145px',
          width: '100%',
          overflow: 'hidden',
          borderRadius: '10px 10px 0px 0px'
        }}>
        {image ? (
          <img src={image} className='h-full object-cover w-full' />
        ) : (
          <div className='w-full h-full flex items-center justify-center text-4xl bg-gray-light'>
            🥘
          </div>
        )}
      </div>
      <div
        className='absolute top-0 left-0 w-full h-[145px] bg-none rounded-t-[10px] z-100 hover:bg-black hover:bg-opacity-30 transition-all'
        onMouseEnter={() => setCardHovered(true)}
        onMouseLeave={() => setCardHovered(false)}>
        {checkboxDisplay && (
          <div className='absolute top-3 left-4 z-[1000000000]'>
            <Input
              type='checkbox'
              name='new'
              checked={checked}
              checkColor='red'
              onChange={onSelect}
              className=''
            />
          </div>
        )}

        {cardHovered && actions && <div className=' absolute top-3 right-3'>{actions}</div>}
      </div>

      <div className='mt-2 px-4 font-medium relative'>{children}</div>
    </div>
  );
};

export default FeedCard;
